/**
 * Created by andrey on 28.08.2024
 */

cleverapps.whenAllInitialized(() => {
    if (!connector.platform.oneOf(connector.TEST)) {
        return;
    }

    // eslint-disable-next-line no-global-assign
    setInterval = cleverapps.extendFunc(setInterval, function (func, interval) {
        const creationStack = new Error().stack;
        let wrapper = function (...args) {
            if (cc.game.isPaused()) {
                console.error(creationStack);
                cleverapps.throwAsync(`background interval - ${creationStack}`);
                wrapper = func;
            }

            return func.call(this, ...args);
        };

        return this._super(function (...args) {
            return wrapper.call(this, ...args);
        }, interval);
    });
});